import { requiresDocusignForKyc } from "../../../../shared/kycAuthentication";
import { Accordion, Alert, Badge, Button, Card, Divider, Grid, Group, Modal, Image, Paper, SimpleGrid, Space, Stack, Text, TextInput, ThemeIcon, Box, Title, Checkbox, ActionIcon, Tooltip, Menu, NumberFormatter, SegmentedControl, Textarea } from '@mantine/core'
import { IconAlertCircle, IconCalendarEvent, IconCheck, IconEdit, IconGalaxy, IconPhone, IconSchool, IconTool, IconTrash, IconWreckingBall, IconX, IconMoneybag } from '@tabler/icons-react';
import EditableInfoCard from '../customers/EditableInfoCard';
import { ActionType, ALWAYS_SELECTED_PAGES, BaseResult, CustomClaims, DocType, GenericProduct, SendServiceSMSRequest, Service, ServiceActionRequest, ServiceStatusCode, UpdateLink, UpdatedDataType, RejectionFormValues, CreateContractLink, UpdateOrderRequest, OrderRefreshRequest, UploadFileResult, CustomFileWithPath, PortfolioType, Portfolio, InvoicePaymentConfirmation, GenerateContractProps, ProductType, KYC, SigningMethod } from '../../types';
import { collection, deleteField, doc, DocumentData, DocumentReference, QueryDocumentSnapshot, updateDoc } from 'firebase/firestore';
import ProductLayout from '../../components/products_details_layout';
import { FirebaseError } from 'firebase/app';
import { useContext, useEffect, useMemo, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { useFirestore, useFunctions } from '../../helpers/firebaseContext';
import { AppConfigContext, ConfigContext, MyUserDataContext } from '../../contexts';
import { useForm, UseFormReturnType } from '@mantine/form';
import GeneratePDFModal from '../../components/generate_pdf_modal';
import { servicePaths } from '../../helpers/orderFilesPath';
import { Link } from 'react-router-dom';
import { CustomInfoCard } from '../customers/CustomInfoCard';
import { getCustomerFromPaciPersonalData } from '../../helpers/common';
import { getAddressDetailsEnglish } from '../../helpers/addressHelpers';
import useApprovals from '../../helpers/useApprovals';
import { FilesList } from '../../components/files';
import { MessagesSent, refreshWhatsappTemplates } from '../../components/send_sms_modal';
import { modals, openConfirmModal } from '@mantine/modals';
import AddPortfolioId from '../../components/add_portfolio_id';
import CustomRejectionModal from '../../components/custom_rejection_modal';
import { notifications } from '@mantine/notifications';
import CustomProductComment from '../../components/custom_product_comment'
import CustomProductTimeline from '../../components/custom_product_timeline';
import AddPortfolioManager from '../../components/add_portfolio_manager';

import { isValidIBAN } from 'ibantools';
import { generateIBANFromKFHAccountNo, getKFHAccountNo, hasVerifiedKfhIban } from '../../utils';
import { deleteObject, getStorage, ref, uploadBytesResumable } from 'firebase/storage';
import BankAccountInfo from '../BankAccountInfo';
import { FileRejection, FileWithPath } from '@mantine/dropzone';

import EditPortfolioFees from '../../components/edit_portfolio_fees';
import UpdateSubPortfolioReason from '../../components/update_sub_portfolio_reason';
import { IbanInfoCard } from '../../components/iban_info_card';
import AddInitialAmount from '../../components/add_initial_amount';
import { UploadBox } from '../../components/upload_box';
import { uploadToStorage } from '../../helpers/uploadToStorage';
import { RmInformationCard } from '../../components/rm_information_card';
import ChangeRmModalContent from '../../components/change_rm_modal';
import UpdateKfhtradeKycDatesModalContent from '../../components/update_kfhtrade_kyc_dates_modal';

type GenevaResponseKey = keyof NonNullable<Service["geneva_responses"]>;
const GENEVA_RESPONSE_FIELDS: Record<PortfolioType, Array<{ key: GenevaResponseKey; label: string }>> = {
    "dpm": [
        { key: "create_portfolio", label: "Create Portfolio" },
        { key: "create_management_fee_expense_manager", label: "Expense Manager - Management Fee" },
        { key: "create_custodian_KCC_2040664_expense_manager", label: "Expense Manager - Custodian KCC_2040664 " },
        { key: "create_custodian_KCC_965080_expense_manager", label: "Expense Manager - Custodian KCC_965080 " },
        { key: "create_deposit_KWD", label: "Deposit Transaction (KWD)" },
        { key: "create_deposit_USD", label: "Deposit Transaction (USD)" },

    ],
    "non-dpm": [
        { key: "create_portfolio", label: "Create Portfolio" },
        { key: "create_management_fee_expense_manager", label: "Expense Manager - Management Fee" },
        { key: "create_custodian_KCC_2040664_expense_manager", label: "Expense Manager - Custodian KCC_2040664 " },
        { key: "create_custodian_KCC_965080_expense_manager", label: "Expense Manager - Custodian KCC_965080 " },
        { key: "create_deposit_KWD", label: "Deposit Transaction (KWD)" },
        { key: "create_deposit_USD", label: "Deposit Transaction (USD)" },

    ],
    "custody": [
        { key: "create_portfolio", label: "Create Portfolio" },
        { key: "create_management_fee_expense_manager", label: "Expense Manager - Management Fee" },
        { key: "create_custodian_KCC_2040664_expense_manager", label: "Expense Manager - Custodian KCC_2040664 " },
        { key: "create_custodian_KCC_965080_expense_manager", label: "Expense Manager - Custodian KCC_965080 " },
        { key: "create_deposit_KWD", label: "Deposit Transaction (KWD)" },
        { key: "create_deposit_USD", label: "Deposit Transaction (USD)" },

    ],
};

type GenevaResponsePayload = Record<string, string | undefined> & {
    status?: string;
    code?: string;
    status_message?: string;
};

export interface ServiceInfoProps {
    service: Service,
    customerRef: DocumentReference,
    serviceRef: DocumentReference,
    serviceDoc?: QueryDocumentSnapshot<Service>
    // updatedServiceData?: any
    // kycCompleted?: boolean
}

const ServiceInfo = ({ serviceDoc, service, customerRef, serviceRef }: ServiceInfoProps) => {

    const userData = useContext(MyUserDataContext);
    const appConfigContext = useContext(AppConfigContext);
    const config = useContext(ConfigContext);
    const storage = getStorage();

    let userClaims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims || {};
    const [confirmDialog, setConfirmDialog] = useState<any>(null);
    const [uploadFinalSignedAgreementOpened, setUploadFinalSignedAgreementOpened] = useState(false);
    const [finalSignedAgreementLoading, setFinalSignedAgreementLoading] = useState(false);
    const [confirming, setConfirming] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [kycData, setKycData] = useState<DocumentData | null>(null);
    const [kycTags, setKycTags] = useState<DocumentData | null>(null);
    const [kycState, setKycState] = useState<DocumentData | undefined>(undefined);
    const [draftActionLoading, setDraftActionLoading] = useState(false);
    const [SMSDocID, setSMSDocID] = useState<string>();
    const [useWhatsapp, setUseWhatsapp] = useState(false);
    const [serviceSigningMethod, setServiceSigningMethod] = useState<SigningMethod>("paci");
    // Entities authenticate through their signatory; only other-ID-only individuals require DocuSign.
    const isOtherIdOnlyCustomer = requiresDocusignForKyc(service?.customerObj ?? {});
    const [uploadSlipOpened, setUploadSlipOpened] = useState(false);
    const [forceRefreshFiles, setForceRefreshFiles] = useState<number | null>()
    const [pending, setPending] = useState(false);
    const [msg, setMsg] = useState(null as any);
    const [isError, setIsError] = useState(false);
    const [clearFiles, setClearFiles] = useState<any>(false);
    const [generatePDFOpen, setGeneratePDFOpen] = useState(false);
    const [confirmDialogError, setConfirmDialogError] = useState<any>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [links, setLinks] = useState([] as any[]);
    const [deletingGenevaKey, setDeletingGenevaKey] = useState<GenevaResponseKey | null>(null);
    const [addingKfhtradeAccount, setAddingKfhtradeAccount] = useState(false);
    const [updateKfhtradeKycDatesOpen, setUpdateKfhtradeKycDatesOpen] = useState(false);
    const [changeRmOpen, setChangeRmOpen] = useState(false);
    const [changeReferredByRmOpen, setChangeReferredByRmOpen] = useState(false);

    const [metaTypes, setMetaTypes] = useState<DocType[]>([]);  //this is for CustomerKYC to set the metatypes of files that exist on the KYC.  That way, we can populate the Generate PDF form properly.
    const [servicePaymentConfirmations, setServicePaymentConfirmations] = useState<InvoicePaymentConfirmation[]>([]);


    const db = useFirestore();

    let kycCompleted: boolean = false;


    // let userClaims = userData.firebaseTokenResult?.claims.customClaims as CustomClaims || {};
    const paciData = getCustomerFromPaciPersonalData(service?.paciData);

    // const customerData =
    //     (service?.paciData ? { ...getCustomerFromPaciPersonalData(service?.paciData) } : (service.customerObj)) as (Customer & KYC)


    let actionToTakeLabel: string | null = null;
    let actionToTake: ActionType | null = null;
    let actionColor: string = "";
    let serviceStatusCode = service.tags?.serviceStatus?.code as ServiceStatusCode;

    const functions = useFunctions();

    const sendGeneratedContractPDF = httpsCallable<{ productRef: string, customerID: string, productType: ProductType }, BaseResult>(functions, "sendGeneratedContractPDF");


    let disableServiceRejectAction = true;
    if (serviceStatusCode !== ServiceStatusCode.rejected && serviceStatusCode !== ServiceStatusCode.done) {
        disableServiceRejectAction = false;
    }


    if (kycData?.created && service.created && (kycState?.status_code === "valid" || service.manual)) {
        //compare the day and make sure the kyc date is always the same or after the order date.  Ignore the time.
        let kycDate = kycData?.created?.toDate();


        kycDate.setHours(0, 0, 0, 0);
        let serviceDate = service.created?.toDate();
        serviceDate.setHours(0, 0, 0, 0);

        if (kycDate >= serviceDate) {
            kycCompleted = true;
        }
    }
    //TODO: use the workflows.ts for these steps instead of hardcoding them here.
    if (serviceStatusCode === ServiceStatusCode.authorized_signatory_approval && (userClaims.cr || userClaims.admin)) {
        actionToTakeLabel = "Authorized Signatory Approve";
        actionToTake = "authorized_signatory_approve";
        actionColor = "cyan";
    }
    if (serviceStatusCode === ServiceStatusCode.review && (userClaims.cr || userClaims.admin)) {
        actionToTakeLabel = "Review";
        actionToTake = "review";
        actionColor = "blue";
    }
    if (serviceStatusCode === ServiceStatusCode.approval && (userClaims.cr || userClaims.admin)) {
        actionToTakeLabel = "Approve";
        actionToTake = "approve";
        actionColor = "green";
    }
    // else if (serviceStatusCode === ServiceStatusCode.waiting_for_sub_account_id && (userClaims.cr || userClaims.admin)) {
    //     actionToTakeLabel = "Add Sub Account ID";
    //     actionToTake = "add_subaccount_id";
    //     actionColor = "lime";
    // }
    else if (serviceStatusCode === ServiceStatusCode.waiting_for_execution && ((service.serviceType === "kfhtrade" && userClaims.cr) || userClaims.admin)) {
        actionToTakeLabel = "Execute";
        actionToTake = "execution";
        actionColor = "blue";
    }
    else if (serviceStatusCode === ServiceStatusCode.waiting_for_operations_approval && ((service.serviceType === "portfolio" && userClaims.oper) || userClaims.admin)) {
        actionToTakeLabel = "Approval (OPER)";
        actionToTake = "execution";
        actionColor = "blue";
    } else if (serviceStatusCode === ServiceStatusCode.waiting_for_activation && (userClaims.oper || userClaims.admin)) {
        actionToTakeLabel = "Activate";
        actionToTake = "activation";
        actionColor = "violet";
    }

    const serviceAction = httpsCallable<ServiceActionRequest, BaseResult>(functions, 'serviceAction');
    const serviceRefresh = httpsCallable<OrderRefreshRequest, BaseResult>(functions, 'serviceRefresh');
    // DocuSign signature verification (operations of the client's segment, or CR/admin)
    const createDocusignContractLink = httpsCallable<CreateContractLink, BaseResult>(functions, "createContractLink");
    const contractKYCUpdateForSignature = httpsCallable<RejectionFormValues, BaseResult>(functions, "contractKYCUpdate");
    const [signatureRejectComments, setSignatureRejectComments] = useState("");
    const [signatureActionLoading, setSignatureActionLoading] = useState(false);
    const syncServiceIbanFromFiles = httpsCallable<{ serviceID: string }, BaseResult>(functions, 'syncServiceIbanFromFiles', { timeout: 300000 });
    //lives in the functions-kfhtrade codebase (customerCreate.ts), same region
    const kfhtradeAddAccount = httpsCallable<{ customerID: string; serviceID: string }, { outcome: 'created' | 'already_exists' | 'failed'; message: string; customerNo?: string }>(functions, 'kfhtradeAddAccount');
    const customPath = `services/${service?.id}/documents`;
    const customFileName = `${kycData?.civilID}-${(kycData as KYC)?.name_en}-${service.serviceType}-${serviceRef.id}`;
    const agreementFileRef = ref(storage, `${customPath}/${customFileName}.pdf`);

    const form: UseFormReturnType<any> = useForm<any>({
        initialValues: {
            updateLink: {
                senderID: ""


            } as UpdateLink,
        }
    })


    const bankAccountForm = useForm<UpdateOrderRequest>({

        initialValues: {
            iban: "",
            account: "",
            transferDate: undefined,
        },

        validate: {
            iban: (value) => {
                if (!value) return "";
                if (value.length === 0) return 'Please enter IBAN';
                if (!isValidIBAN(value)) return 'Invalid IBAN';
                return null;
            },
            account: (value, values) => {
                if (!value) {
                    if (getKFHAccountNo(values.iban ?? "")) {
                        return 'Please enter account number';
                    }
                    return null;
                }
                if (value.length === 0) return 'Please enter account number';
                if (value.length !== 12) return 'Invalid account number';
                return null;
            },
            transferDate: (value) => {
                if (!value) return "Please enter transfer date";
                return null;
            },
        },
    });

    const formatTransferDateForUpload = (date: Date) => {
        const day = `${date.getDate()}`.padStart(2, "0");
        const month = `${date.getMonth() + 1}`.padStart(2, "0");
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    // Custom submit handler for service rejection
    const handleServiceRejection = async (values: RejectionFormValues): Promise<void> => {
        try {
            const token = await userData.getAzureADToken!(userData);
            if (!token) {
                throw new Error("No Microsoft Token. Try refreshing.");
            }

            console.log("Service rejection values:", values);
            const action: ActionType = 'reject';

            // Service action with your specific API
            const result = await serviceAction({
                action: action,
                comments: values.comments,
                sendSMS: values.sendSMS,
                linkInfo: {
                    smsMessage: values.linkInfo?.smsMessage,
                    updateType: values.linkInfo?.updateType,
                    senderID: values.linkInfo?.senderID,
                    usePACI: values.usePACI,
                },
                serviceID: service.id!,
                customerID: customerRef.id,
                token: token,
                missingFiles: values.missingFiles || [],
            });

            console.log("Service action completed:", result);

            // Refresh service
            setRefreshing(true);
            await serviceRefresh({ orderID: service.id! });
            setRefreshing(false);
            console.log("Service refreshed!");

            // Show success notification
            notifications.show({
                title: 'Successfully',
                message: 'Service rejected',
                color: 'green',
            });

        } catch (error: any) {
            console.error("Service rejection error:", error);

            // Show error notification
            notifications.show({
                title: 'Service rejection error:',
                message: error.message || 'Failed to reject service',
                color: 'red',
            });

            // Reset refreshing state if there was an error
            setRefreshing(false);

            // Re-throw the error so the modal can handle it (show error in modal)
            throw error;
        }
    };


    const { actions, actionsAfterRejections } = useApprovals(serviceRef);

    useEffect(() => {
        if (!service) return;

        // handle multiple vs single payment confirmations
        let paymentConfirmations = [] as InvoicePaymentConfirmation[];
        if (service?.payment_confirmations && service?.payment_confirmations?.length > 0) {
            paymentConfirmations = service.payment_confirmations;
        } else if (service?.payment_confirmation) {
            paymentConfirmations = [service.payment_confirmation];
        }
        if (paymentConfirmations.length > 0) {
            paymentConfirmations = paymentConfirmations.map((paymentConfirmation) => {
                return {
                    ...paymentConfirmation,
                    name: undefined,
                    currency: undefined,
                    amountInBaseCurrency: undefined,
                    transferAmountWhenReceived: undefined,
                    transactionTitle: paymentConfirmation.name,
                    transferAmount: paymentConfirmation.amountInBaseCurrency,
                    transferCurrency: paymentConfirmation?.currency,
                    fundName: undefined,
                    clientName: service.customerObj?.name_en,
                    transactionTimestamp: undefined,
                    receivedAt: undefined,
                    transactionDate: paymentConfirmation.transactionTimestamp?.toDate().toLocaleString("en-gb") ?? paymentConfirmation.transactionDate,
                }
            })
        }

        setServicePaymentConfirmations(paymentConfirmations);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [service]);

    useEffect(() => {
        const getData = async () => {

            await refreshWhatsappTemplates(true, form, appConfigContext.apiUrl!, () => { }, false, () => { },
                (config?.serviceTemplates && service.serviceType) ? config?.serviceTemplates[service.serviceType]?.whatsappTemplate : undefined, "updateLink.selectedWhatsappTemplate",
            )
        }
        if (useWhatsapp) { getData() }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [useWhatsapp])


    const getLatestUpdate = (updatedData?: UpdatedDataType[]) => {
        if (!updatedData?.length) return null;
        return updatedData[updatedData.length - 1];
    };

    const getLatestInitialAmountUpdate = (updatedData?: UpdatedDataType[], invoiceIndex?: number) => {
        if (!updatedData?.length) return null;
        const fieldName = `initialAmount#${invoiceIndex}`;
        const filtered = updatedData.filter(entry =>
            entry.updated_field_name?.includes(fieldName)
        );
        if (!filtered.length) return null;
        return filtered[filtered.length - 1];
    };

    // Helper function to format the tooltip content
    const formatTooltip = (update: UpdatedDataType) => {
        const parts = [];

        // Show initial values
        if (update.initial_value && update.initial_value.length > 0) {
            const initialObj = update.initial_value[0];
            Object.entries(initialObj).forEach(([key, value]) => {
                const displayValue = Array.isArray(value) ? value.join(', ') : String(value);
                parts.push(`Previous Value: ${displayValue}`);
            });
        }


        // Show updated values
        if (update.updated_fields && update.updated_fields.length > 0) {
            const updatedObj = update.updated_fields[0];
            Object.entries(updatedObj).forEach(([key, value]) => {
                const displayValue = Array.isArray(value) ? value.join(', ') : String(value);
                parts.push(`Current Value: ${displayValue}`);
            });
        }
        if (update.updated_by) parts.push(`Updated by: ${update.updated_by}`);
        if (update.updated_on) parts.push(`Updated on: ${update.updated_on?.toDate().toDateString()}`);
        if (update.reason) parts.push(`Reason: ${update.reason}`);

        if (parts.length === 0) return 'No additional information';

        return (
            <div>
                {parts.map((part, index) => (
                    <div key={index}>{part}</div>
                ))}
            </div>
        );
    };

    // Build the data for the combined Transfer Invoice + Payment Confirmation cards.
    // Each invoice is matched to its payment confirmations by (toIban, currency). Any
    // confirmations that don't match a transferInvoice are returned separately.
    const transferInvoicesView = useMemo(() => {
        const rawConfirmations: InvoicePaymentConfirmation[] =
            (service?.payment_confirmations && service.payment_confirmations.length > 0)
                ? service.payment_confirmations
                : (service?.payment_confirmation ? [service.payment_confirmation] : []);

        const matchedIndices = new Set<number>();

        const invoices = (service?.transferInvoices ?? []).map((invoice, index) => {
            const matchingConfirmations = rawConfirmations.filter((conf, confIdx) => {
                const ibanMatches = (conf.toIban ?? "") === (invoice.iban ?? "");
                const currencyMatches = (conf.currency ?? "") === (invoice.currency ?? "");
                if (ibanMatches && currencyMatches) {
                    matchedIndices.add(confIdx);
                    return true;
                }
                return false;
            });

            const paidSum = matchingConfirmations.reduce(
                (acc, c) => acc + (c.amountInBaseCurrency ?? 0),
                0,
            );
            const invoiceAmount = invoice.amount ?? 0;
            const remaining = Math.max(invoiceAmount - paidSum, 0);

            let badgeColor: string;
            let badgeLabel: string;
            if (invoiceAmount <= 0) {
                badgeColor = "green";
                badgeLabel = "No Slip Required";
            } else if (paidSum < invoiceAmount && service.tags?.paid?.code === "paid") {
                // The service payment check falls back to a slip when confirmations are insufficient.
                badgeColor = "orange";
                badgeLabel = "Paid through a slip";
            } else if (paidSum <= 0) {
                badgeColor = "red";
                badgeLabel = "Not Paid";
            } else if (paidSum < invoiceAmount) {
                badgeColor = "yellow";
                badgeLabel = "Partially Paid";
            } else {
                badgeColor = "green";
                badgeLabel = "Fully Paid";
            }

            return {
                invoice,
                index,
                paidSum,
                remaining,
                invoiceAmount,
                badgeColor,
                badgeLabel,
                matchingConfirmations,
                latestInitialAmountUpdate: getLatestInitialAmountUpdate(service?.updated_data, index),
            };
        });

        const unmatchedConfirmations = rawConfirmations.filter((_c, i) => !matchedIndices.has(i));

        return { invoices, unmatchedConfirmations };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [service]);


    const latestUpdate = getLatestUpdate(service.updated_data);
    let shouldShowGenevaResponseCard = false;
    let genevaResponseList: any = [];
    let genevaResponsesNeedAttention = false;
    if (service.serviceType === "portfolio") {

        const canDeleteGenevaResponses = Boolean(userClaims?.admin);
        const handleDeleteGenevaResponse = async (key: GenevaResponseKey) => {
            try {
                if (!service?.id) {
                    throw new Error("Missing order ID");
                }
                setDeletingGenevaKey(key);
                await updateDoc(serviceRef, { [`geneva_responses.${key}`]: deleteField() });
                // await orderRefresh({ orderID: order.id });
                notifications.show({
                    title: 'Geneva response deleted',
                    message: `${key} removed for this order.`,
                    color: 'green',
                });
            } catch (error: any) {
                console.error("Failed to delete Geneva response", error);
                notifications.show({
                    title: 'Failed to delete Geneva response',
                    message: error?.message ?? 'Please try again.',
                    color: 'red',
                });
            } finally {
                setDeletingGenevaKey(null);
            }
        };

        const confirmDeleteGenevaResponse = (key: GenevaResponseKey, label: string) => {
            openConfirmModal({
                title: 'Delete Geneva response?',
                children: <Text size="sm">Remove the response for "{label}" from this Service?</Text>,
                labels: { confirm: 'Delete', cancel: 'Cancel' },
                confirmProps: { color: 'red' },
                onConfirm: () => handleDeleteGenevaResponse(key),
            });
        };
        const genevaFieldConfig = GENEVA_RESPONSE_FIELDS[service.portfolioOpeningRequest?.portfolioType!] ?? [];

        let filteredGenevaFieldConfig = genevaFieldConfig;
        const usedTransferCurrencies = new Set<string>(
            (service.transferInvoices ?? [])
                .map((invoice) => invoice.currency?.trim().toUpperCase()))
        if (!usedTransferCurrencies.has("KWD")) {
            filteredGenevaFieldConfig = filteredGenevaFieldConfig.filter(({ key }) => !key.includes("create_deposit_KWD"))
        }
        if (!usedTransferCurrencies.has("USD")) {
            filteredGenevaFieldConfig = filteredGenevaFieldConfig.filter(({ key }) => !key.includes("create_deposit_USD"))
        }


        genevaResponseList = filteredGenevaFieldConfig.map(({ key, label }) => {
            const response = service.geneva_responses?.[key] as GenevaResponsePayload | undefined;
            const hasResponse = !!response && Object.keys(response).length > 0;
            const status = response?.status;
            const normalizedStatus = status?.toLowerCase();
            const isSuccess = hasResponse && normalizedStatus === "success";
            const isAdding = hasResponse && normalizedStatus === "adding";
            const iconColor = !hasResponse ? "gray" : isSuccess ? "teal" : isAdding ? "yellow" : "red";
            const tooltipLines: JSX.Element[] = [];
            if (hasResponse) {
                tooltipLines.push(<Text key="status" size="xs">Status: {status ?? "Unknown"}</Text>);
                if (response?.code) {
                    tooltipLines.push(<Text key="code" size="xs">Code: {response.code}</Text>);
                }
                if (response?.status_message) {
                    tooltipLines.push(<Text key="message" size="xs">Message: {response.status_message}</Text>);
                }
                if (tooltipLines.length === 1 && status === undefined) {
                    tooltipLines.push(<Text key="no-details" size="xs" c="dimmed">No additional details.</Text>);
                }
            }
            if (service.geneva_responses && (!hasResponse || !isSuccess)) {
                genevaResponsesNeedAttention = true;
            }
            const tooltipContent = hasResponse ? (
                <Stack gap={2}>
                    {tooltipLines}
                </Stack>
            ) : (
                <Text size="xs">No response recorded yet.</Text>
            );
            const iconNode = (
                <Tooltip label={tooltipContent} withArrow multiline>
                    <ThemeIcon radius="xl" size="sm" color={iconColor}>
                        {isSuccess ? <IconCheck size={12} /> : isAdding ? <IconAlertCircle size={12} /> : <IconX size={12} />}
                    </ThemeIcon>
                </Tooltip>
            );
            const deleteNode = canDeleteGenevaResponses && hasResponse ? (
                <ActionIcon
                    variant="subtle"
                    color="red"
                    size="sm"
                    loading={deletingGenevaKey === key}
                    onClick={() => confirmDeleteGenevaResponse(key, label)}
                    aria-label="Delete Geneva response"
                >
                    <IconTrash size={12} />
                </ActionIcon>
            ) : null;

            return {
                label,
                value: deleteNode ? <Group gap="xs" justify="flex-end">{iconNode}{deleteNode}</Group> : iconNode,
            };
        });
        shouldShowGenevaResponseCard = Boolean(service.geneva_responses && filteredGenevaFieldConfig.length);
    }

    //KFHTrade OMS auto-provisioning card — same ergonomics as the Geneva
    //responses card: green check on success, red + retry on failure.  The
    //retry just deletes the response entry; onChangeService re-provisions.
    //kfhtrade: a verified KFH IBAN is final (Firestore rules enforce it too); a verified but invalid one can still be fixed
    const kfhtradeIbanEditable = service.serviceType === "kfhtrade" && !hasVerifiedKfhIban(service);
    let shouldShowKfhtradeProvisioningCard = false;
    let kfhtradeProvisioningList: any = [];
    let kfhtradeProvisioningNeedsAttention = false;
    if (service.serviceType === "kfhtrade") {
        const response = service.kfhtrade_responses?.create_customer;
        const hasResponse = !!response && Object.keys(response).length > 0;
        const normalizedStatus = response?.status?.toLowerCase();
        const isSuccess = hasResponse && normalizedStatus === "success";
        const isAdding = hasResponse && normalizedStatus === "adding";
        const iconColor = !hasResponse ? "gray" : isSuccess ? "teal" : isAdding ? "yellow" : "red";
        kfhtradeProvisioningNeedsAttention = hasResponse && !isSuccess && !isAdding;

        const tooltipContent = hasResponse ? (
            <Stack gap={2}>
                <Text size="xs">Status: {response?.status ?? "Unknown"}</Text>
                {response?.key_value && <Text size="xs">Customer No: {response.key_value}</Text>}
                {response?.status_message && <Text size="xs">Message: {response.status_message}</Text>}
            </Stack>
        ) : (
            <Text size="xs">No response recorded yet.</Text>
        );
        const iconNode = (
            <Tooltip label={tooltipContent} withArrow multiline>
                <ThemeIcon radius="xl" size="sm" color={iconColor}>
                    {isSuccess ? <IconCheck size={12} /> : isAdding ? <IconAlertCircle size={12} /> : <IconX size={12} />}
                </ThemeIcon>
            </Tooltip>
        );

        const canRetryProvisioning = Boolean(userClaims?.admin) && hasResponse && !isSuccess && !isAdding;
        const retryNode = canRetryProvisioning ? (
            <ActionIcon
                variant="subtle"
                color="red"
                size="sm"
                onClick={() => openConfirmModal({
                    title: 'Retry KFHTrade provisioning?',
                    children: <Text size="sm">This removes the failed OMS response so the customer create can run again: automatically when auto-create is on (config/kfhtrade_oms), otherwise with "Add KFHTrade Account" (admin / CR).</Text>,
                    labels: { confirm: 'Retry', cancel: 'Cancel' },
                    confirmProps: { color: 'red' },
                    onConfirm: async () => {
                        try {
                            await updateDoc(serviceRef, { "kfhtrade_responses.create_customer": deleteField() });
                            notifications.show({
                                title: 'Provisioning response cleared',
                                message: 'The OMS create runs again automatically when auto-create is on; otherwise an admin or CR uses "Add KFHTrade Account".',
                                color: 'green',
                            });
                        } catch (error: any) {
                            console.error("Failed to queue KFHTrade provisioning retry", error);
                            notifications.show({
                                title: 'Failed to queue retry',
                                message: error?.message ?? 'Please try again.',
                                color: 'red',
                            });
                        }
                    },
                })}
                aria-label="Retry KFHTrade provisioning"
            >
                <IconTrash size={12} />
            </ActionIcon>
        ) : null;

        kfhtradeProvisioningList = [{
            label: "Create Customer (OMS)",
            value: retryNode ? <Group gap="xs" justify="flex-end">{iconNode}{retryNode}</Group> : iconNode,
        }];

        //last manual KYC/civil ID expiry push (the "Update KFHTrade KYC Dates" button)
        const kycDatesResponse = service.kfhtrade_responses?.update_kyc_dates;
        const hasKycDatesResponse = !!kycDatesResponse && Object.keys(kycDatesResponse).length > 0;
        if (hasKycDatesResponse) {
            const kycDatesSuccess = kycDatesResponse?.status?.toLowerCase() === "success";
            kfhtradeProvisioningNeedsAttention = kfhtradeProvisioningNeedsAttention || !kycDatesSuccess;
            const kycDatesTooltip = (
                <Stack gap={2}>
                    <Text size="xs">Status: {kycDatesResponse?.status ?? "Unknown"}</Text>
                    {kycDatesResponse?.payload?.kycExpiryDate && <Text size="xs">KYC expiry: {kycDatesResponse.payload.kycExpiryDate}</Text>}
                    {kycDatesResponse?.payload?.civilIdExpiryDate && <Text size="xs">Civil ID expiry: {kycDatesResponse.payload.civilIdExpiryDate}</Text>}
                    {kycDatesResponse?.by && <Text size="xs">By: {kycDatesResponse.by}</Text>}
                    {kycDatesResponse?.timestamp && <Text size="xs">At: {kycDatesResponse.timestamp.toDate().toLocaleString()}</Text>}
                    {kycDatesResponse?.status_message && <Text size="xs">Message: {kycDatesResponse.status_message}</Text>}
                </Stack>
            );
            kfhtradeProvisioningList.push({
                label: "Update KYC Dates (OMS)",
                value: (
                    <Tooltip label={kycDatesTooltip} withArrow multiline>
                        <ThemeIcon radius="xl" size="sm" color={kycDatesSuccess ? "teal" : "red"}>
                            {kycDatesSuccess ? <IconCheck size={12} /> : <IconX size={12} />}
                        </ThemeIcon>
                    </Tooltip>
                ),
            });
        }
        shouldShowKfhtradeProvisioningCard = hasResponse || hasKycDatesResponse || serviceStatusCode === ServiceStatusCode.processing;
    }

    return (
        <div>

            <Space h="xl" />

            <Card shadow="sm" padding="lg" radius="md" withBorder>

                <Group justify="space-between" mt="md" mb="xs">

                    <Menu shadow="md" width={200}>
                        <Menu.Target>
                            <Button
                                color="violet"
                                loading={pending}
                            // disabled={(!kycCompleted)}
                            >
                                Generate PDF
                            </Button>
                        </Menu.Target>

                        <Menu.Dropdown>

                            {((service?.serviceType === "portfolio" && service?.tags?.serviceStatus?.code === ServiceStatusCode.done && (userClaims?.admin || userClaims.cr)) && kycCompleted) && <Menu.Item>
                                <Button
                                    color="red"
                                    onClick={
                                        () => openConfirmModal({
                                            onConfirm: async () => {
                                                setConfirming(true);
                                                try {

                                                    await sendGeneratedContractPDF({
                                                        productRef: (serviceRef.path as string),
                                                        customerID: customerRef.id,
                                                        productType: "services",
                                                    })
                                                    notifications.show({
                                                        message: "contract sent successfully",
                                                        color: "green"
                                                    })
                                                } catch (e) {
                                                    notifications.show({
                                                        message: "an error occured",
                                                        color: "red"
                                                    })
                                                }
                                                setConfirming(false);

                                            },
                                            title: <Title order={2} c="red">
                                                Send to client
                                            </Title>,
                                            children: (
                                                <>
                                                    <Title order={3} c="red">
                                                        Are you sure you want to send the document to the client
                                                    </Title>
                                                    <Text c="red" td="underline" fw="bold">
                                                        This action cannot be reverted
                                                    </Text>
                                                </>
                                            ),


                                            labels: { confirm: 'Send', cancel: 'Cancel' },
                                            confirmProps: {
                                                color: "red",
                                                loading: confirming
                                                // disabled: true,

                                            },
                                            cancelProps: {
                                                loading: confirming
                                                // disabled: true,
                                            }
                                        })
                                    }
                                >

                                    Send to client
                                </Button>
                            </Menu.Item>}
                            <>
                                {console.log("Render menu items! kycCompleted:", kycCompleted, "service.manual:", service.manual)}
                            </>
                            {(service.manual && !kycCompleted) ? <Menu.Item
                                onClick={
                                    () => {
                                        setGeneratePDFOpen(true)
                                    }
                                }
                            >
                                Generate Empty Form
                            </Menu.Item> : kycCompleted ? <Menu.Item>
                                <Button
                                    onClick={() => setGeneratePDFOpen(true)}>
                                    Generate PDF
                                </Button>
                            </Menu.Item> : null}

                        </Menu.Dropdown>
                    </Menu>

                    <Button color="green" loading={refreshing} type="button" onClick={

                        async () => {

                            setRefreshing(true);
                            await serviceRefresh({ orderID: service.id! });
                            setRefreshing(false);
                            console.log("Service refreshed!");
                        }

                    }>
                        Refresh Service
                    </Button>

                    {service.manual && <Button color='pink' onClick={() => setUploadFinalSignedAgreementOpened(true)} disabled={serviceStatusCode === "rejected"}>
                        Upload Agreement
                    </Button>}
                    <Modal
                        size={'xl'}
                        opened={uploadFinalSignedAgreementOpened}
                        onClose={() => { setUploadFinalSignedAgreementOpened(false); }}
                        title="Signed Agreement"
                    >
                        <Card withBorder>
                            <UploadBox
                                loading={finalSignedAgreementLoading}
                                label="Drag Signed Agreement here or click to select file"
                                multiple={false}
                                onDropAny={async (files, filesRejected: FileRejection[], setUploadedFiles, uploadedFiles?: FileWithPath[]) => {

                                    if (!files || files?.length === 0) return;
                                    console.log("Files dropped!", files, filesRejected, uploadedFiles);

                                    setFinalSignedAgreementLoading(true);
                                    //upload file to fileUpload endpoint
                                    const promises = files.map(async (file) => {
                                        let tags: Record<string, string> = {};
                                        tags.finalSignedAgreement = 'true';
                                        if (service.id) {
                                            await uploadToStorage(file, 'services/' + service.id, tags);
                                        }
                                        if (customerRef.id) {
                                            await uploadToStorage(file, 'kyc/' + customerRef.id, tags);
                                        }
                                        if (agreementFileRef) {
                                            await uploadBytesResumable(ref(agreementFileRef, customFileName), file);
                                        }
                                    });

                                    await Promise.all(promises);
                                    // const messaging = getMessaging(getApp());

                                    //wait 6 seconds.  I can't know when the thumbnail is ready.
                                    await new Promise((resolve) => {
                                        setTimeout(() => {
                                            resolve(true);
                                        }, 6000);
                                    });
                                    setUploadFinalSignedAgreementOpened(false);
                                    setFinalSignedAgreementLoading(false);
                                }}
                            />
                        </Card>
                    </Modal>
                    {service.serviceType === "portfolio" &&
                        <>
                            <Button onClick={() => setUploadSlipOpened(true)} disabled={serviceStatusCode === "rejected"}>

                                Upload Slip {serviceStatusCode === "rejected" ? " (Service Rejected)" : ""}
                            </Button>
                            <Modal
                                size={"xl"}
                                opened={uploadSlipOpened}
                                onClose={() => {

                                    //remove any uploaded slips
                                    bankAccountForm.values.slipFilePaths?.forEach((slipPath) => {
                                        ///
                                        const deleteRef = ref(storage, `${slipPath}`);

                                        deleteObject(deleteRef).then(() => {
                                            serviceRefresh({ orderID: service.id! }).then(() => {

                                                setForceRefreshFiles(Math.random())

                                            });

                                            // File deleted successfully
                                        }).catch((error) => {

                                            console.error(error);

                                            // Uh-oh, an error occurred!
                                        });
                                    })


                                    setUploadSlipOpened(false);
                                }}
                                title="Upload Slip"
                            >

                                <form onSubmit={bankAccountForm.onSubmit(async (values) => {

                                    if (!values.iban || !values.transferDate) {
                                        // setIsError(true);
                                        // setMsg("Please fill out all fields");
                                        return;
                                    }

                                    setPending(true);

                                    try {
                                        const slipFilePaths = bankAccountForm.values.slipFilePaths || [];
                                        if (!slipFilePaths.length) {
                                            throw new Error("Please upload at least one slip before finalizing");
                                        }

                                        const formData = new FormData();
                                        formData.append("type", "service_slip");
                                        formData.append("serviceID", service.id!);
                                        formData.append("finalizeSlip", "true");
                                        formData.append("iban", values.iban);
                                        formData.append("acct", values.account || "");
                                        formData.append("transferDate", formatTransferDateForUpload(values.transferDate));
                                        slipFilePaths.forEach((slipPath: string) => {
                                            formData.append("slipFilePaths[]", slipPath);
                                        });

                                        const response = await (await fetch(`${appConfigContext.apiUrl}/uploadFile`, {
                                            method: "POST",
                                            body: formData,
                                        })).json() as UploadFileResult & { reason?: any };

                                        if (response.status === "error") {
                                            throw new Error(response.message || response.reason?.message || "Failed to finalize slip");
                                        }

                                        console.log("Service refreshed!");
                                        setForceRefreshFiles(Math.random())
                                        await serviceRefresh({ orderID: service.id! });
                                        bankAccountForm.reset()
                                        setUploadSlipOpened(false)
                                    } catch (error) {
                                        await serviceRefresh({ orderID: service.id! });
                                        setIsError(true);
                                        setMsg("Failed to upload slip: " + (error instanceof Error ? error.message : String(error)));
                                    } finally {
                                        setPending(false);
                                    }
                                    setForceRefreshFiles(Math.random())

                                })}>
                                    <BankAccountInfo
                                        serviceID={service.id}
                                        deferFinalize={true}
                                        ibanProps={
                                            {
                                                ...bankAccountForm.getInputProps("iban")
                                                ,
                                                required: true
                                            }

                                        }
                                        transferDateProps={
                                            {
                                                ...bankAccountForm.getInputProps("transferDate"),
                                                required: true
                                            }
                                        }
                                        acctNumberProps={
                                            { ...bankAccountForm.getInputProps("account"), }
                                        }

                                        onBlurIban={
                                            () => {
                                                console.log("Blurring!");
                                                if (bankAccountForm.values?.iban && bankAccountForm.values.iban.length === 30) {
                                                    let acct = getKFHAccountNo(bankAccountForm.values.iban);
                                                    if (acct) {
                                                        bankAccountForm.setFieldValue("account", acct);
                                                    }
                                                }
                                            }
                                        }

                                        onBlurAccountNumber={
                                            () => {
                                                if (bankAccountForm.values.account && bankAccountForm.values.account.length === 12) {
                                                    bankAccountForm.setFieldValue("iban", generateIBANFromKFHAccountNo(bankAccountForm.values.account) || "");
                                                }
                                            }

                                        }

                                        handleUploadResponse={
                                            (response: UploadFileResult, filesName: string[], setUploadedFiles?: (values?: FileWithPath[]) => void, filesList?: CustomFileWithPath[], currentFiles?: FileWithPath[]) => {


                                                filesName.map((fileName: string) => {
                                                    const fileInfo = response.info![fileName];
                                                    console.log(fileInfo)


                                                    if (fileInfo && setUploadedFiles) {
                                                        if (filesList) {

                                                            setUploadedFiles(
                                                                currentFiles?.concat({ ...fileInfo, name: fileName, serverPath: (fileInfo as CustomFileWithPath).serverPath })
                                                            )
                                                        }
                                                    }

                                                    if (fileInfo.metadata?.acct) bankAccountForm.setFieldValue("account", fileInfo.metadata?.acct);
                                                    if (fileInfo.metadata?.iban) bankAccountForm.setFieldValue("iban", fileInfo.metadata?.iban);

                                                    if (fileInfo.metadata?.amount) bankAccountForm.setFieldValue("transferAmount", fileInfo.metadata?.amount);

                                                    if (fileInfo.metadata?.transferDate) {
                                                        let d = fileInfo.metadata?.transferDate.split("/");
                                                        let transferDate = new Date(`${d[1]}-${d[0]}-${d[2]}`);
                                                        console.log("Setting transfer date to", transferDate);
                                                        bankAccountForm.setFieldValue("transferDate", transferDate);
                                                    }

                                                    return fileInfo.filepath;
                                                })
                                                if (response.filePaths?.length) {
                                                    bankAccountForm.setFieldValue("slipFilePaths", response.filePaths)

                                                }
                                                else {

                                                    bankAccountForm.setFieldValue("slipFilePaths", response.info!.filepaths)
                                                }



                                            }

                                        }

                                        setIsError={setIsError}
                                        setMsg={setMsg}
                                        clearFiles={clearFiles}
                                        onRemoveFile={
                                            (file) => {

                                                const deleteRef = ref(storage, `${(file as CustomFileWithPath).serverPath}`);

                                                // Delete the file
                                                deleteObject(deleteRef).then(() => {
                                                    serviceRefresh({ orderID: service.id! }).then(() => {

                                                        setForceRefreshFiles(Math.random())


                                                    });

                                                    // File deleted successfully
                                                }).catch((error) => {

                                                    console.error(error);

                                                    // Uh-oh, an error occurred!
                                                });

                                                bankAccountForm.setFieldValue("slipFilePaths",
                                                    bankAccountForm.values.slipFilePaths?.filter((path: string) => (path?.split("/").pop() !== (file as CustomFileWithPath).serverPath?.split("/").pop())
                                                    ))


                                                // serviceRefresh({ orderID: order.id! });


                                            }
                                        }

                                    />




                                    {
                                        msg != null &&   //love my check if it's an error or not.  Please don't do this, it's just a proof of concept page.
                                        <Alert color={isError ? "red" : "green"}>
                                            {msg}
                                        </Alert>
                                    }

                                    <Group justify="center" mt="md">
                                        <Button
                                            type="submit"
                                            loading={pending}
                                        // disabled={isSubmitted}
                                        >
                                            Upload Slip
                                        </Button>
                                        <Button
                                            loading={pending}
                                            color="red" type="button"
                                            // disabled={isSubmitted}
                                            onClick={() => {
                                                setClearFiles(Math.random())
                                                //remove any uploaded slips
                                                bankAccountForm.values.slipFilePaths?.forEach((slipPath) => {
                                                    ///
                                                    const deleteRef = ref(storage, `${slipPath}`);

                                                    deleteObject(deleteRef).then(() => {
                                                        serviceRefresh({ orderID: service.id! }).then(() => {

                                                            setForceRefreshFiles(Math.random())

                                                        });

                                                        // File deleted successfully
                                                    }).catch((error) => {

                                                        console.error(error);

                                                        // Uh-oh, an error occurred!
                                                    });
                                                })

                                                setUploadSlipOpened(false)
                                                setMsg(null)

                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Group>
                                </form>
                            </Modal>
                        </>}
                </Group>
            </Card>
            <Space h="xl" />
            <ProductLayout<Service>
                defaultOpen={["service"]}
                productDoc={serviceDoc}
                product={service}
                customerRef={customerRef}
                productRef={serviceRef}
                showGeneratePDF={false}
                setParentKycData={setKycData}
                showActiveLinks={true}
                setParentKycTags={setKycTags}
                setParentKycState={setKycState}
                metaTypes={metaTypes}
                setMetaTypes={setMetaTypes}
            >
                <Accordion.Item key="service" value="service">
                    <Accordion.Control >
                        <Group p="apart">
                            <ThemeIcon
                                variant="gradient"
                                size="xl"
                                aria-label="Gradient action icon"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                            >
                                <IconTool size={30} />
                            </ThemeIcon>
                            <Text
                                component="span"
                                ta="center"
                                variant="gradient"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                                size="xl"
                                fw={700}
                                style={{ fontFamily: 'Greycliff CF, sans-serif' }}
                            >
                                Service Information
                            </Text>
                        </Group>
                    </Accordion.Control>
                    <Space h={"xl"} />

                    <Accordion.Panel>


                        <SimpleGrid cols={3}>

                            <EditableInfoCard<Service>
                                title="Service Information"
                                color="teal"
                                attention={(service.serviceType === "portfolio" && !service.portfolioOpeningRequest?.portfolioId)}
                                itemDoc={serviceDoc}
                                updatedItemData={{}}
                                icon={<IconWreckingBall size={16} />}
                                list={[

                                    {
                                        label: 'Date',
                                        value: service.created?.toDate().toDateString()
                                    },


                                    {

                                        label: 'Type',
                                        value: service.serviceType
                                    },
                                    {
                                        label: "KYC Status",
                                        value:

                                            <Link to={`/customers/${customerRef?.id}`}>

                                                {kycCompleted ? <Text c="green">{kycTags?.title}</Text> : <Text c="yellow">{kycState?.status || "No KYC"}</Text>}
                                            </Link>

                                    },

                                    ...((service && service.serviceType === "portfolio") ? [

                                        ...(service.portfolioOpeningRequest?.isSubPortfolio
                                            ? [{
                                                label: (
                                                    <Text span>
                                                        {'Main Portfolio ID'}
                                                        {latestUpdate && (
                                                            <Tooltip
                                                                label={formatTooltip(latestUpdate)}
                                                                withArrow
                                                                multiline
                                                            >
                                                                <IconAlertCircle
                                                                    size={16}
                                                                    style={{
                                                                        marginLeft: 6,
                                                                        verticalAlign: 'middle',
                                                                        color: 'orange',
                                                                        cursor: 'help'
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                    </Text>
                                                ),
                                                value: <>
                                                    {!service.portfolioOpeningRequest?.portfolioId &&
                                                        <>
                                                            <Text size="xs" c="red" ta="right">(Add Main Portfolio ID)</Text>
                                                        </>}
                                                    {service.portfolioOpeningRequest?.portfolioId &&
                                                        <>
                                                            <Text span fw={500} size="sm" ta="right">
                                                                {service.portfolioOpeningRequest?.mainPortfolioId}
                                                            </Text>
                                                        </>}
                                                    {!service.geneva_responses && <ActionIcon variant="white" aria-label="Add Portfolio Id" onClick={() => {
                                                        modals.open({
                                                            title: 'Add Main Portfolio ID',
                                                            children: (
                                                                <AddPortfolioId serviceRef={serviceRef} service={service} fieldType="mainPortfolioId" />
                                                            ),
                                                        });
                                                    }}>
                                                        <IconEdit style={{ width: '70%', height: '70%' }} stroke={1.5} />
                                                    </ActionIcon>}
                                                </>
                                            },]
                                            : []
                                        ),
                                        {
                                            label: (
                                                <Text span>
                                                    {'Portfolio ID'}
                                                    {latestUpdate && (latestUpdate?.updated_field_name ?? []).includes('portfolioId') && (
                                                        <Tooltip
                                                            label={formatTooltip(latestUpdate)}
                                                            withArrow
                                                            multiline
                                                        >
                                                            <IconAlertCircle
                                                                size={16}
                                                                style={{
                                                                    marginLeft: 6,
                                                                    verticalAlign: 'middle',
                                                                    color: 'orange',
                                                                    cursor: 'help'
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    )}
                                                </Text>
                                            ),
                                            value: <>
                                                {!service.portfolioOpeningRequest?.portfolioId &&
                                                    <>
                                                        <Text size="xs" c="red" ta="right">(Add Portfolio ID)</Text>
                                                    </>}
                                                {service.portfolioOpeningRequest?.portfolioId &&
                                                    <>
                                                        <Text span fw={500} size="sm" ta="right">
                                                            {service.portfolioOpeningRequest?.portfolioId}
                                                        </Text>
                                                    </>}
                                                {!service.geneva_responses && <ActionIcon variant="white" aria-label="Add Portfolio Id" onClick={() => {
                                                    modals.open({
                                                        title: 'Add Portfolio ID',
                                                        children: (
                                                            <AddPortfolioId serviceRef={serviceRef} service={service} fieldType="portfolioId" />
                                                        ),
                                                    });
                                                }}>
                                                    <IconEdit style={{ width: '70%', height: '70%' }} stroke={1.5} />
                                                </ActionIcon>}
                                            </>
                                        },

                                        {
                                            label: (
                                                <Text span>
                                                    {'Portfolio Manager'}

                                                </Text>
                                            ),
                                            value: <>
                                                {!service.portfolioOpeningRequest?.portfolioManager &&
                                                    <>
                                                        <Text size="xs" c="red" ta="right">(Add Portfolio Manager)</Text>
                                                    </>}
                                                {service.portfolioOpeningRequest?.portfolioManager &&
                                                    <>
                                                        <Text span fw={500} size="sm" ta="right">
                                                            {service.portfolioOpeningRequest?.portfolioManager}
                                                        </Text>
                                                    </>}
                                                {!service.geneva_responses && <ActionIcon variant="white" aria-label="Add Portfolio Manager" onClick={() => {
                                                    modals.open({
                                                        title: 'Add Portfolio Manager',
                                                        children: (
                                                            <AddPortfolioManager service={service} serviceRef={serviceRef} />
                                                        ),
                                                    });
                                                }}>
                                                    <IconEdit style={{ width: '70%', height: '70%' }} stroke={1.5} />
                                                </ActionIcon>}
                                            </>
                                        },
                                        {
                                            label: (
                                                <Text span>
                                                    {'Portfolio Fees - Percentage'}
                                                </Text>
                                            ),
                                            value: <>
                                                {!service.portfolioOpeningRequest?.fees &&
                                                    <>
                                                        <Text size="xs" c="red" ta="right">(Add Portfolio Fees)</Text>
                                                    </>}
                                                {service.portfolioOpeningRequest?.fees !== undefined &&
                                                    <>
                                                        <Text span fw={500} size="sm" ta="right">
                                                            {service.portfolioOpeningRequest?.fees}
                                                        </Text>
                                                    </>}
                                                {!service.geneva_responses && (userClaims.admin) && <ActionIcon variant="white" aria-label="Edit Portfolio Fees" onClick={() => {
                                                    modals.open({
                                                        title: 'Edit Portfolio Fees (Percentage)',
                                                        children: (
                                                            <EditPortfolioFees service={service} serviceRef={serviceRef} />
                                                        ),
                                                    });
                                                }}>
                                                    <IconEdit style={{ width: '70%', height: '70%' }} stroke={1.5} />
                                                </ActionIcon>}
                                            </>
                                        },
                                        {
                                            label: 'Transfer Amount',
                                            value: service.portfolioOpeningRequest?.transferAmount
                                        },
                                        {
                                            label: 'Portfolio currency',
                                            value: service.portfolioOpeningRequest?.currency
                                        },
                                        {
                                            label: 'Portfolio Category',
                                            value: service.portfolioOpeningRequest?.portfolio_db_id
                                        },
                                        {
                                            label: 'Portfolio Type',
                                            value: service.portfolioOpeningRequest?.portfolioType
                                        },
                                        {
                                            label: 'Risk Tolerance',
                                            value: service.portfolioOpeningRequest?.riskTolerance
                                        },
                                        {
                                            label: 'Asset Class',
                                            value: service.portfolioOpeningRequest?.assetClass
                                        },
                                        ...(service.portfolioOpeningRequest?.isSubPortfolio
                                            ? [{
                                                label: 'Sub Portfolio Reason',
                                                value: <>
                                                    {!kycData?.sub_portfolio_reason && (
                                                        <Text size="xs" c="red" ta="right">
                                                            (Add Sub Portfolio Reason)
                                                        </Text>
                                                    )}
                                                    {kycData?.sub_portfolio_reason && (
                                                        <Text span fw={500} size="sm" ta="right">
                                                            {kycData.sub_portfolio_reason}
                                                        </Text>
                                                    )}
                                                    <ActionIcon
                                                        variant="white"
                                                        aria-label="Edit Sub Portfolio Reason"
                                                        onClick={() => {
                                                            modals.open({
                                                                title: 'Update Sub Portfolio Reason',
                                                                children: (
                                                                    <UpdateSubPortfolioReason
                                                                        customerId={customerRef.id}
                                                                        kycId={kycData?.id}
                                                                        currentValue={kycData?.sub_portfolio_reason || ''}
                                                                    />
                                                                ),
                                                                size: 'lg',
                                                            });
                                                        }}
                                                    >
                                                        <IconEdit style={{ width: '70%', height: '70%' }} stroke={1.5} />
                                                    </ActionIcon>
                                                </>
                                            }] : []),
                                    ] : (service && service.serviceType === "kfhtrade") ? [
                                        {
                                            label: "KCC external_ref ",
                                            value: service?.kcc?.external_ref
                                        }
                                        , {
                                            label: "KCC status_code ",
                                            value: service?.kcc?.status_code
                                        }
                                        , {
                                            label: "KCC status_message ",
                                            value: service?.kcc?.status_message
                                        }
                                        , {
                                            label: "KCC lastImportedAt ",
                                            value: service?.kcc?.lastImportedAt?.toDate().toISOString(),
                                        }
                                    ] : []),




                                ]}

                            />

                            <RmInformationCard
                                product={service}
                                onEditRm={userClaims["admin"] ? () => setChangeRmOpen(true) : undefined}
                                onEditReferredBy={userClaims["admin"] ? () => setChangeReferredByRmOpen(true) : undefined}
                            />

                            {shouldShowGenevaResponseCard && (
                                <CustomInfoCard
                                    title="Geneva Responses"
                                    color="pink"
                                    attention={genevaResponsesNeedAttention}
                                    icon={<IconGalaxy size={16} />}
                                    list={genevaResponseList}
                                />
                            )}

                            {shouldShowKfhtradeProvisioningCard && (
                                <CustomInfoCard
                                    title="KFHTrade Provisioning"
                                    color="cyan"
                                    attention={kfhtradeProvisioningNeedsAttention}
                                    icon={<IconTool size={16} />}
                                    list={kfhtradeProvisioningList}
                                />
                            )}

                            {service.serviceType === "kfhtrade" && (!!userClaims?.admin || !!userClaims?.cr) && (
                                <Button
                                    mt="sm"
                                    variant="light"
                                    color="cyan"
                                    leftSection={<IconTool size={14} />}
                                    loading={addingKfhtradeAccount}
                                    onClick={() => openConfirmModal({
                                        title: 'Add KFHTrade Account?',
                                        children: <Text size="sm">Creates this client on the KFHTrade OMS now via the create-customer API, whatever the service status (except Waiting For Sub Account ID and Need IBAN: those come first). Overwrites any previous provisioning response. Clients that already have a KFHTrade ID are never re-created.</Text>,
                                        labels: { confirm: 'Create on OMS', cancel: 'Cancel' },
                                        confirmProps: { color: 'cyan' },
                                        onConfirm: async () => {
                                            setAddingKfhtradeAccount(true);
                                            try {
                                                const result = await kfhtradeAddAccount({ customerID: customerRef.id, serviceID: service.id! });
                                                const { outcome, message, customerNo } = result.data;
                                                notifications.show({
                                                    title: outcome === 'failed' ? 'KFHTrade provisioning failed'
                                                        : outcome === 'already_exists' ? 'KFHTrade account already exists'
                                                            : 'KFHTrade account created',
                                                    message: customerNo ? `${message} (Customer No: ${customerNo})` : message,
                                                    color: outcome === 'failed' ? 'red' : 'green',
                                                });
                                            } catch (error: any) {
                                                console.error("kfhtradeAddAccount failed", error);
                                                notifications.show({
                                                    title: 'KFHTrade provisioning error',
                                                    message: error?.message ?? 'Unknown error',
                                                    color: 'red',
                                                });
                                            } finally {
                                                setAddingKfhtradeAccount(false);
                                            }
                                        },
                                    })}
                                >
                                    Add KFHTrade Account
                                </Button>
                            )}

                            {service.serviceType === "kfhtrade" && !!userClaims?.admin && (
                                <Button
                                    mt="sm"
                                    variant="light"
                                    color="cyan"
                                    leftSection={<IconCalendarEvent size={14} />}
                                    onClick={() => setUpdateKfhtradeKycDatesOpen(true)}
                                >
                                    Update KFHTrade KYC Dates
                                </Button>
                            )}

                            <CustomInfoCard
                                title="Client Information"
                                color="yellow"
                                icon={<IconPhone size={16} />}
                                list={[
                                    {
                                        label: "Name (en)",
                                        value: service.customerObj?.name_en,
                                    },
                                    {
                                        label: "Name (ar)",
                                        value: service.customerObj?.name_ar,
                                    },
                                    {
                                        label: "Commercial Register",
                                        value: service.customerObj?.commercial_register,
                                    },

                                    {
                                        label: "Civil ID",
                                        value: service.customerObj?.civilID,
                                    },
                                    {
                                        label: "Civil ID Expiry",
                                        value: paciData?.civilIDExpiryDate?.toDate().toLocaleDateString("en-gb")
                                    },

                                    {
                                        label: "Mobile",
                                        value: service.customerObj?.mobile,
                                    },
                                    {
                                        label: "Nationality",
                                        value: service.customerObj?.nationality,
                                    },
                                    {
                                        label: "Gender",
                                        value: service.customerObj?.gender,
                                    },
                                    {
                                        label: "PACI Sponsor",
                                        value: service.paciData?.PersonalData?.GovData?.SponsorName || undefined
                                    },
                                    {
                                        label: "PACI Mobile",
                                        value: service.paciData?.PersonalData?.MobileNumber || undefined
                                    },
                                    {
                                        label: "PACI Email",
                                        value: service.paciData?.PersonalData?.EmailAddress || undefined,
                                        noCapitalize: true,
                                    },

                                    {
                                        label: "Address (en)",
                                        value: paciData?.address?.DetailsEnglish,
                                    },

                                    {
                                        label: "Address (ar)",
                                        value: paciData?.address?.DetailsArabic,
                                    },
                                    {
                                        label: "Address",
                                        value: paciData?.address ? getAddressDetailsEnglish(paciData?.address) : null,
                                    },
                                    // ...Object.keys(data?.address).map((key) => {return {label: key, value: data?.address[key]}} )
                                ]}
                            />

                            {(service.iban || service.serviceType === "kfhtrade") && <IbanInfoCard
                                acct={service.acct}
                                allowSetIban={kfhtradeIbanEditable}
                                requireValidKfhIban={service.serviceType === "kfhtrade"}
                                certificateUploadPath={kfhtradeIbanEditable ? `services/${service.id}` : undefined}
                                onCertificateUploaded={() => setForceRefreshFiles(Math.random())}
                                onSyncFromFiles={kfhtradeIbanEditable ? async () => {
                                    try {
                                        const result = await syncServiceIbanFromFiles({ serviceID: service.id! });
                                        notifications.show({
                                            title: result.data.status === "success" ? "IBAN synced" : "IBAN not found",
                                            message: result.data.message ?? "",
                                            color: result.data.status === "success" ? "green" : "yellow",
                                        });
                                    } catch (error) {
                                        notifications.show({ title: "Failed to sync IBAN", message: error instanceof Error ? error.message : String(error), color: "red" });
                                    }
                                    setForceRefreshFiles(Math.random());
                                } : undefined}
                                customerRef={customerRef}
                                entityLabel="service"
                                entityRef={serviceRef}
                                iban={service.iban}
                                ibanVerified={service.ibanVerified}
                                userClaims={userClaims}
                                verifiedBy={service.verifiedBy}
                                verifierIdentity={userData.user?.email || userData.user?.uid || 'Unknown user'}
                            />}


                            {service.signature &&


                                <CustomInfoCard
                                    title="Signature"
                                    color="violet"
                                    icon={
                                        <IconSchool size={16} />
                                    }
                                    list={[

                                        {
                                            label: '',
                                            value: service.signature && <Image
                                                fit="contain"
                                                w="auto"
                                                mah={200}
                                                maw="100%"
                                                src={`data:image/png;base64,${service.signature}`}
                                            />
                                        },


                                    ]}
                                />
                            }

                            {transferInvoicesView.invoices.map(({
                                invoice,
                                index,
                                paidSum,
                                remaining,
                                invoiceAmount,
                                badgeColor,
                                badgeLabel,
                                matchingConfirmations,
                                latestInitialAmountUpdate,
                            }) => (
                                <Paper key={`invoice-${index}`} shadow="xs" p="md">
                                    <Group justify="space-between" wrap="nowrap" align="flex-start" mb="sm">
                                        <Group wrap="nowrap" gap="xs">
                                            <ThemeIcon color="yellow" variant="light">
                                                <IconMoneybag size={16} />
                                            </ThemeIcon>
                                            <Title order={5}>{invoice.currency} Transfer Invoice</Title>
                                        </Group>
                                        <Badge color={badgeColor} variant="light">{badgeLabel}</Badge>
                                    </Group>

                                    <Stack gap="xs">
                                        <Group justify="space-between">
                                            <Group gap={4}>
                                                <Text size="sm" c="dimmed">Initial Transfer Amount</Text>
                                                {latestInitialAmountUpdate && (
                                                    <Tooltip label={formatTooltip(latestInitialAmountUpdate)} withArrow multiline>
                                                        <IconAlertCircle
                                                            size={14}
                                                            style={{ verticalAlign: 'middle', color: 'orange', cursor: 'help' }}
                                                        />
                                                    </Tooltip>
                                                )}
                                            </Group>
                                            <Group gap={4} wrap="nowrap">
                                                {invoice.initialAmount != null
                                                    ? <Text fw={500} size="sm" ta="right">
                                                        <NumberFormatter thousandSeparator value={invoice.initialAmount} />
                                                    </Text>
                                                    : <Text size="xs" c="dimmed" ta="right">(Not Set)</Text>
                                                }
                                                {!service.geneva_responses && (
                                                    <ActionIcon
                                                        variant="subtle"
                                                        size="sm"
                                                        aria-label="Edit Initial Amount"
                                                        onClick={() => {
                                                            modals.open({
                                                                title: 'Edit Initial Amount',
                                                                children: (
                                                                    <AddInitialAmount serviceRef={serviceRef} service={service} invoiceIndex={index} />
                                                                ),
                                                            });
                                                        }}
                                                    >
                                                        <IconEdit style={{ width: '70%', height: '70%' }} stroke={1.5} />
                                                    </ActionIcon>
                                                )}
                                            </Group>
                                        </Group>

                                        <Group justify="space-between">
                                            <Text size="sm" c="dimmed">Amount</Text>
                                            <Text fw={500} size="sm" ta="right">
                                                <NumberFormatter thousandSeparator value={invoiceAmount} /> {invoice.currency}
                                            </Text>
                                        </Group>

                                        {!!invoice.tradingCommissionAmount && (
                                            <Group justify="space-between">
                                                <Text size="sm" c="dimmed">Trading Commission</Text>
                                                <Text fw={500} size="sm" ta="right">
                                                    <NumberFormatter thousandSeparator value={invoice.tradingCommissionAmount} />
                                                </Text>
                                            </Group>
                                        )}

                                        {invoice.iban && (
                                            <Group justify="space-between" wrap="nowrap">
                                                <Text size="sm" c="dimmed">IBAN</Text>
                                                <Text fw={500} size="sm" ta="right" style={{ wordBreak: 'break-all' }}>
                                                    {invoice.iban}
                                                </Text>
                                            </Group>
                                        )}

                                        {paidSum > 0 && (
                                            <Group justify="space-between">
                                                <Text size="sm" c="dimmed">Paid</Text>
                                                <Text fw={500} size="sm" c="green" ta="right">
                                                    <NumberFormatter thousandSeparator value={paidSum} />
                                                </Text>
                                            </Group>
                                        )}

                                        {paidSum > 0 && remaining > 0 && (
                                            <Group justify="space-between">
                                                <Text size="sm" c="dimmed">Remaining</Text>
                                                <Text fw={500} size="sm" c="orange" ta="right">
                                                    <NumberFormatter thousandSeparator value={remaining} />
                                                </Text>
                                            </Group>
                                        )}
                                    </Stack>

                                    {matchingConfirmations.length > 0 && (
                                        <>
                                            <Divider
                                                my="md"
                                                label={
                                                    matchingConfirmations.length > 1
                                                        ? `Payment Confirmations (${matchingConfirmations.length})`
                                                        : 'Payment Confirmation'
                                                }
                                                labelPosition="left"
                                            />
                                            <Accordion variant="separated" radius="sm" multiple chevronPosition="right">
                                                {matchingConfirmations.map((confirmation, confIdx) => (
                                                    <Accordion.Item
                                                        key={`conf-${index}-${confIdx}`}
                                                        value={`conf-${index}-${confIdx}`}
                                                    >
                                                        <Accordion.Control>
                                                            <Group justify="space-between" wrap="nowrap" pr="sm">
                                                                <Text size="sm" fw={600}>
                                                                    Payment #{confIdx + 1}
                                                                </Text>
                                                                <Text size="sm" fw={500}>
                                                                    {confirmation.amountInBaseCurrency != null
                                                                        ? <NumberFormatter thousandSeparator value={confirmation.amountInBaseCurrency} />
                                                                        : "-"}
                                                                    {' '}{confirmation.currency ?? invoice.currency}
                                                                </Text>
                                                            </Group>
                                                        </Accordion.Control>
                                                        <Accordion.Panel>
                                                            <Stack gap={4}>
                                                                {confirmation.amountInKWD != null && (
                                                                    <Group justify="space-between">
                                                                        <Text size="xs" c="dimmed">Amount (KWD)</Text>
                                                                        <Text size="sm" ta="right">
                                                                            <NumberFormatter thousandSeparator value={confirmation.amountInKWD} />
                                                                        </Text>
                                                                    </Group>
                                                                )}
                                                                {confirmation.exchangeRate != null && (
                                                                    <Group justify="space-between">
                                                                        <Text size="xs" c="dimmed">Exchange Rate</Text>
                                                                        <Text size="sm" ta="right">
                                                                            <NumberFormatter thousandSeparator value={confirmation.exchangeRate} />
                                                                        </Text>
                                                                    </Group>
                                                                )}
                                                                <Group justify="space-between" wrap="nowrap">
                                                                    <Text size="xs" c="dimmed">From IBAN</Text>
                                                                    <Text size="xs" ta="right" style={{ wordBreak: 'break-all' }}>
                                                                        {confirmation.fromIban}
                                                                    </Text>
                                                                </Group>
                                                                <Group justify="space-between">
                                                                    <Text size="xs" c="dimmed">Date</Text>
                                                                    <Text size="xs" ta="right">
                                                                        {confirmation.transactionTimestamp?.toDate().toLocaleString("en-gb") ?? confirmation.transactionDate}
                                                                    </Text>
                                                                </Group>
                                                                {confirmation.transactionID && (
                                                                    <Group justify="space-between" wrap="nowrap">
                                                                        <Text size="xs" c="dimmed">Transaction ID</Text>
                                                                        <Text size="xs" ta="right" style={{ wordBreak: 'break-all' }}>
                                                                            {confirmation.transactionID}
                                                                        </Text>
                                                                    </Group>
                                                                )}
                                                            </Stack>
                                                        </Accordion.Panel>
                                                    </Accordion.Item>
                                                ))}
                                            </Accordion>
                                        </>
                                    )}
                                </Paper>
                            ))}

                            {transferInvoicesView.unmatchedConfirmations.length > 0 && (
                                <Paper key="unmatched-confirmations" shadow="xs" p="md">
                                    <Group justify="space-between" wrap="nowrap" align="flex-start" mb="sm">
                                        <Group wrap="nowrap" gap="xs">
                                            <ThemeIcon color="orange" variant="light">
                                                <IconMoneybag size={16} />
                                            </ThemeIcon>
                                            <Title order={5}>Unmatched Payment Confirmations</Title>
                                        </Group>
                                        <Badge color="orange" variant="light">Unmatched</Badge>
                                    </Group>

                                    <Accordion variant="separated" radius="sm" multiple chevronPosition="right">
                                        {transferInvoicesView.unmatchedConfirmations.map((confirmation, confIdx) => (
                                            <Accordion.Item
                                                key={`unmatched-${confIdx}`}
                                                value={`unmatched-${confIdx}`}
                                            >
                                                <Accordion.Control>
                                                    <Group justify="space-between" wrap="nowrap" pr="sm">
                                                        <Text size="sm" fw={600}>
                                                            Payment #{confIdx + 1}
                                                        </Text>
                                                        <Text size="sm" fw={500}>
                                                            {confirmation.amountInBaseCurrency != null
                                                                ? <NumberFormatter thousandSeparator value={confirmation.amountInBaseCurrency} />
                                                                : "-"}
                                                            {confirmation.currency ? ` ${confirmation.currency}` : ''}
                                                        </Text>
                                                    </Group>
                                                </Accordion.Control>
                                                <Accordion.Panel>
                                                    <Stack gap={4}>
                                                        {confirmation.amountInKWD != null && (
                                                            <Group justify="space-between">
                                                                <Text size="xs" c="dimmed">Amount (KWD)</Text>
                                                                <Text size="sm" ta="right">
                                                                    <NumberFormatter thousandSeparator value={confirmation.amountInKWD} />
                                                                </Text>
                                                            </Group>
                                                        )}
                                                        {confirmation.exchangeRate != null && (
                                                            <Group justify="space-between">
                                                                <Text size="xs" c="dimmed">Exchange Rate</Text>
                                                                <Text size="sm" ta="right">
                                                                    <NumberFormatter thousandSeparator value={confirmation.exchangeRate} />
                                                                </Text>
                                                            </Group>
                                                        )}
                                                        <Group justify="space-between" wrap="nowrap">
                                                            <Text size="xs" c="dimmed">From IBAN</Text>
                                                            <Text size="xs" ta="right" style={{ wordBreak: 'break-all' }}>
                                                                {confirmation.fromIban}
                                                            </Text>
                                                        </Group>
                                                        <Group justify="space-between" wrap="nowrap">
                                                            <Text size="xs" c="dimmed">To IBAN</Text>
                                                            <Text size="xs" ta="right" style={{ wordBreak: 'break-all' }}>
                                                                {confirmation.toIban}
                                                            </Text>
                                                        </Group>
                                                        <Group justify="space-between">
                                                            <Text size="xs" c="dimmed">Date</Text>
                                                            <Text size="xs" ta="right">
                                                                {confirmation.transactionTimestamp?.toDate().toLocaleString("en-gb") ?? confirmation.transactionDate}
                                                            </Text>
                                                        </Group>
                                                        {confirmation.transactionID && (
                                                            <Group justify="space-between" wrap="nowrap">
                                                                <Text size="xs" c="dimmed">Transaction ID</Text>
                                                                <Text size="xs" ta="right" style={{ wordBreak: 'break-all' }}>
                                                                    {confirmation.transactionID}
                                                                </Text>
                                                            </Group>
                                                        )}
                                                    </Stack>
                                                </Accordion.Panel>
                                            </Accordion.Item>
                                        ))}
                                    </Accordion>
                                </Paper>
                            )}


                        </SimpleGrid>


                        <Title order={3}>Files</Title>
                        <FilesList
                            forceRefresh={forceRefreshFiles}
                            setMetaTypes={setMetaTypes}
                            path={`services/${service.id}/`}
                            links={links}
                            setLinks={setLinks}
                            showUploader={false}
                            onChange={() => {
                                serviceRefresh({ orderID: service.id! });
                            }}
                        />



                        {serviceStatusCode === ServiceStatusCode.signature_verification && (() => {
                            const envelope = service.docusignData;
                            const serviceSegment = service.segment ?? service.customerObj?.segment ?? service.rm?.segment;
                            const sameSegmentOperations = userClaims.kfh_oper === true && !!serviceSegment && !!userClaims.segment
                                && `${userClaims.segment}`.trim().toLowerCase() === `${serviceSegment}`.trim().toLowerCase();
                            const canVerifySignature = userClaims.admin === true || userClaims.cram === true || userClaims.cr === true || sameSegmentOperations;
                            const runSignatureAction = async (action: "verify_signature" | "reject_signature") => {
                                setSignatureActionLoading(true);
                                try {
                                    const token = await userData.getAzureADToken?.(userData).catch(() => undefined);
                                    await serviceAction({ action, serviceID: service.id!, customerID: customerRef.id, token: token || "", comments: signatureRejectComments || undefined } as ServiceActionRequest);
                                    if (action === "reject_signature") {
                                        if (service.kyc_id) {
                                            // Same as a CR rejection: needs_update on the existing KYC + an update link the
                                            // client re-signs through DocuSign, so the SAME KYC is updated and re-reviewed.
                                            await contractKYCUpdateForSignature({
                                                action: "reject_signature",
                                                kycID: service.kyc_id,
                                                customerID: customerRef.id,
                                                selectedPages: [...ALWAYS_SELECTED_PAGES],
                                                comments: signatureRejectComments,
                                                token: token || "",
                                                sendSMS: false,
                                                usePACI: false,
                                                linkInfo: { updateType: "needs_update" },
                                            });
                                        } else {
                                            // no KYC on the service yet: fresh DocuSign contract link + WhatsApp to the client
                                            await createDocusignContractLink({ productRef: `services/${service.id}`, customerID: customerRef.id, token: token || "", signingMethod: "docusign" });
                                        }
                                    }
                                    await serviceRefresh({ orderID: service.id! });
                                    setSignatureRejectComments("");
                                    notifications.show({ title: "Done", message: action === "verify_signature" ? "DocuSign signature confirmed" : "Signature rejected and a new DocuSign link was sent to the client", color: "green" });
                                } catch (e: any) {
                                    notifications.show({ title: "Error", message: e?.message ?? "Action failed", color: "red" });
                                }
                                setSignatureActionLoading(false);
                            };
                            return <Paper withBorder p="md" radius="md" mt={20}>
                                <Stack gap="xs">
                                    <Title order={5}>DocuSign signature verification</Title>
                                    <Text size="sm">
                                        This client has no Kuwait Civil ID, so the contract was signed through DocuSign instead of PACI.
                                        Operations must confirm the signature is genuine before the request continues. The sealed contract and certificate of completion are in the service files.
                                    </Text>
                                    {envelope && <Text size="sm" c="dimmed">
                                        Envelope {envelope.envelopeId} · signer {envelope.signerName ?? "-"} ({envelope.signerEmail ?? envelope.signerPhone ?? "-"})
                                        {envelope.completedAt?.toDate ? ` · completed ${envelope.completedAt.toDate().toLocaleString("en-GB")}` : ""}
                                    </Text>}
                                    {canVerifySignature ? <>
                                        <Textarea
                                            label="Rejection reason (required only when rejecting)"
                                            placeholder="e.g. signature does not match the passport"
                                            value={signatureRejectComments}
                                            onChange={(e) => setSignatureRejectComments(e.currentTarget.value)}
                                            autosize minRows={2}
                                        />
                                        <Group>
                                            <Button color="green" loading={signatureActionLoading} onClick={() => setConfirmDialog({
                                                title: "Confirm signature",
                                                action: "Confirm",
                                                description: `Confirm that ${service.customerObj?.name_en}'s DocuSign signature is genuine?`,
                                                buttonColor: "green",
                                                callback: () => runSignatureAction("verify_signature"),
                                            })}>
                                                Confirm signature
                                            </Button>
                                            <Button color="red" variant="outline" loading={signatureActionLoading} disabled={!signatureRejectComments.trim()} onClick={() => setConfirmDialog({
                                                title: "Reject signature",
                                                action: "Reject & resend",
                                                description: `Reject the signature and send ${service.customerObj?.name_en} a new DocuSign contract?`,
                                                buttonColor: "red",
                                                callback: () => runSignatureAction("reject_signature"),
                                            })}>
                                                Reject & request new DocuSign signature
                                            </Button>
                                        </Group>
                                    </> : <Text size="sm" c="dimmed">
                                        Waiting for KFH operations of the "{serviceSegment ?? "unknown"}" segment (or KFH Capital CR/admin) to verify the signature.
                                    </Text>}
                                </Stack>
                            </Paper>;
                        })()}

                        {serviceStatusCode === ServiceStatusCode.need_signature &&

                            <Grid mt={20}>
                                {service.serviceType === "portfolio" && (
                                    <Grid.Col span={8}>
                                        <Stack gap={6}>
                                            <Text size="sm" fw={500}>Contract signing method</Text>
                                            <SegmentedControl
                                                value={isOtherIdOnlyCustomer ? "docusign" : serviceSigningMethod}
                                                disabled={isOtherIdOnlyCustomer}
                                                data={[
                                                    { value: "paci", label: "PACI / Kuwait Mobile ID" },
                                                    { value: "docusign", label: "DocuSign email" },
                                                ]}
                                                onChange={(value) => setServiceSigningMethod(value as SigningMethod)}
                                            />
                                            {isOtherIdOnlyCustomer && (
                                                <Text size="xs" c="dimmed">
                                                    Client has no Kuwait Civil ID (Other ID only): PACI is not available, the contract goes through DocuSign by e-mail.
                                                </Text>
                                            )}
                                        </Stack>
                                    </Grid.Col>
                                )}
                                <Grid.Col span={4}>

                                    <Button type="button" name="send_sms"
                                        loading={draftActionLoading}
                                        onClick={async () => {
                                            setDraftActionLoading(true);


                                            const createContractLink = httpsCallable<CreateContractLink, BaseResult>(functions, "createContractLink");
                                            const sendServiceSMS = httpsCallable<SendServiceSMSRequest, BaseResult>(functions, "sendServiceSMS");

                                            if (service.serviceType === "portfolio") {
                                                const res = await createContractLink({
                                                    productRef: `services/${service.id}`,
                                                    customerID: customerRef.id,
                                                    token: await userData.getAzureADToken!(userData),
                                                    signingMethod: isOtherIdOnlyCustomer ? "docusign" : serviceSigningMethod,
                                                });

                                                console.log("Create contract link response:", res);

                                            } else {
                                                //generate a doc ID
                                                const docID = doc(collection(db, "sms")).id;
                                                setSMSDocID(docID);
                                                //set type to submit because we want the user to create an entirely new KYC
                                                await sendServiceSMS({
                                                    service: service,
                                                    smsDocID: docID,
                                                    token: await userData.getAzureADToken!(userData),

                                                    type: useWhatsapp ? "whatsapp" : "sms"

                                                });
                                            }




                                            setDraftActionLoading(false);

                                            // notifications.show({
                                            //     title: 'SMS Sent',
                                            //     message: 'Client should receive an SMS shortly',
                                            // })



                                            //call function to send SMS
                                        }}>
                                        Re-send Service SMS
                                    </Button>

                                </Grid.Col>
                                {/* <Grid.Col span={6}>

                                    {(userClaims.admin || userClaims.cr) && <Checkbox
                                        checked={useWhatsapp}
                                        label="send through whatsapp"
                                        onChange={(e) => {
                                            setUseWhatsapp(e.target.checked)

                                            setSMSDocID(undefined);

                                        }}
                                    />}

                                </Grid.Col> */}
                                <Grid.Col span={6}>
                                    {(SMSDocID) &&

                                        <MessagesSent docID={SMSDocID} handleFailedMessages={() => {
                                            const handleOrderSMS = async () => {

                                                const sendServiceSMS = httpsCallable<SendServiceSMSRequest, BaseResult>(functions, "sendServiceSMS");


                                                //generate a doc ID
                                                const docID = doc(collection(db, "sms")).id;
                                                setSMSDocID(docID);

                                                //set type to submit because we want the user to create an entirely new KYC
                                                await sendServiceSMS({
                                                    service: service!,
                                                    smsDocID: docID,
                                                    token: await userData.getAzureADToken!(userData)
                                                });
                                            }
                                            handleOrderSMS();
                                        }} />

                                    }
                                </Grid.Col>

                                {/* {deleteButton} */}

                            </Grid>
                        }

                        <Stack gap="md">
                            <Grid gap="lg">
                                {/* show approval */}
                                {actions.length > 0 && (<Grid.Col span={{ base: 12, md: 6 }}>
                                    <CustomProductTimeline approval={actions} />
                                </Grid.Col>)}
                                <Grid.Col span={{ base: 12, md: 6 }}>
                                    {/* Show product comments */}
                                    <CustomProductComment
                                        collectionRef={serviceRef}
                                    />
                                </Grid.Col>
                            </Grid>
                            <Box mt="md" pt="md" style={{ borderTop: '1px solid var(--mantine-color-gray-3)' }} />
                        </Stack>

                        <Group mt={20}>


                            {actionToTake &&
                                <Button disabled={

                                    false
                                    //     (!kycCompleted
                                    //         && !isOrderAndKycSameState
                                    //         && !isKycInApproveAndOrderInReview)
                                    // || ((serviceStatusCode === "review"
                                    //     || serviceStatusCode === "approval")
                                    //     && !allFilesTagged
                                    // )
                                }
                                    color={actionColor} type="button" name="approve" onClick={async () => {


                                        setConfirmDialog({
                                            title: "Confirm",
                                            action: actionToTakeLabel,
                                            description: `${actionToTakeLabel} ${service.customerObj?.name_en}'s service?`,
                                            buttonColor: actionColor,
                                            callback: async () => {

                                                //The action needs Microzift's accessToken so I can verify groups from the server side.
                                                let token = await userData.getAzureADToken!(userData);

                                                if (!token) {
                                                    throw new FirebaseError("no_microsoft_token", "No Microsoft token.  Try refreshing");
                                                }




                                                await serviceAction({ action: actionToTake as ActionType, serviceID: service.id!, customerID: customerRef.id, token: token });
                                                setRefreshing(true);
                                                await serviceRefresh({ orderID: service.id! });
                                                setRefreshing(false);
                                                console.log("Service refreshed!");
                                            }
                                        })
                                    }}>
                                    {actionToTakeLabel} {!kycState ? "(No valid KYC)" : ""}
                                </Button>
                            }


                            <CustomRejectionModal
                                onSubmit={handleServiceRejection}
                                title="Reject Service"
                                submitButtonText="Reject"
                                submitButtonColor="red"
                                triggerButtonText="Reject"
                                triggerButtonColor="red"
                                triggerButtonDisabled={disableServiceRejectAction}
                                showSMSOptions={true}
                                showUpdateLinkOptions={true}
                            />

                        </Group>

                        <Modal
                            opened={confirmDialog != null}
                            onClose={() => { setConfirmDialog(null); setConfirmDialogError(null); }}
                            title={<Title order={3}>{confirmDialog?.title}</Title>}
                        >

                            <form onSubmit={form.onSubmit(async (values) => {
                                setConfirmDialogError(null);
                                setConfirming(true);
                                try {
                                    await confirmDialog?.callback(values);
                                    setConfirmDialog(null);
                                } catch (error: any) {
                                    setConfirmDialogError(error.message);
                                }
                                setConfirming(false);

                            })}>
                                <Stack>

                                    <Text fw={300}>{confirmDialog?.description}</Text>
                                    {/* <Space h="xl"/> */}
                                    {confirmDialog?.textField && <><Text>{confirmDialog?.textFieldDescription}</Text><TextInput  {...form.getInputProps(confirmDialog.textField)} /></>}
                                    <Button color={confirmDialog?.buttonColor} type="submit" loading={confirming}>{confirmDialog?.action}</Button>
                                    {confirmDialogError && <Alert icon={<IconAlertCircle size={16} />} title="Whoops!" c="red">{confirmDialogError}</Alert>}
                                </Stack>
                            </form>
                        </Modal>
                    </Accordion.Panel>
                </Accordion.Item>

            </ProductLayout>

            <Modal
                opened={changeRmOpen}
                onClose={() => setChangeRmOpen(false)}
                title="Change RM"
            >
                <ChangeRmModalContent
                    onClose={() => {
                        setChangeRmOpen(false);
                    }}
                    serviceId={service.id}
                    productType="service"
                    type="primary"
                />
            </Modal>

            <Modal
                opened={updateKfhtradeKycDatesOpen}
                onClose={() => setUpdateKfhtradeKycDatesOpen(false)}
                title="Update KFHTrade KYC Dates"
            >
                {updateKfhtradeKycDatesOpen && (
                    <UpdateKfhtradeKycDatesModalContent
                        service={service}
                        customerRef={customerRef}
                        onClose={() => setUpdateKfhtradeKycDatesOpen(false)}
                    />
                )}
            </Modal>

            <Modal
                opened={changeReferredByRmOpen}
                onClose={() => setChangeReferredByRmOpen(false)}
                title="Change Referred by RM"
            >
                <ChangeRmModalContent
                    onClose={() => {
                        setChangeReferredByRmOpen(false);
                    }}
                    serviceId={service.id}
                    productType="service"
                    type="referred"
                />
            </Modal>


            <GeneratePDFModal
                generatingForCollection="service"
                getCustomerDataKey={"customerObj"}
                // generatedType={"order"}
                objID={service.id}
                completedKYCData={kycData?.completedKYCData ? {
                    ...kycData.completedKYCData,
                    kyc_id: kycData.id
                } : null}
                pdfTags={kycData?.pdfTags ? kycData.pdfTags : null}
                paymentConfirmations={servicePaymentConfirmations}
                rows={[{


                    ...service,
                    ...kycData,
                    customerID: kycData?.civilID,
                    id: service.id,
                    iban: service?.iban,
                    documentActions: actionsAfterRejections,

                    address: {
                        ...kycData?.address, "DetailsEnglish":
                            kycData?.address ? getAddressDetailsEnglish(kycData?.address)
                                : "",
                    },

                }]}



                // getCustomerDataKey={null}
                documentsToFetch={
                    [{
                        name: "services",
                        subCollectionAccessorName: "id",
                        documentsToAddFunction: (serviceObj: GenericProduct) => {
                            //show kfh trade form even for new KYC as it not implemented yet
                            // // skip adding any documents for this service new KYC with contract.
                            // if (kycData?.completedKYCData && serviceObj?.serviceType === "kfhtrade") {
                            //     return [];
                            // }
                            return (serviceObj?.serviceType) ? servicePaths[serviceObj?.serviceType] : []
                        },
                        type: "collectionGroup"

                    }]
                }

                metaTypes={metaTypes}
                withFilledKYC={kycCompleted}
                manual={service.manual}
                kycID={kycData?.id}
                opened={generatePDFOpen}
                setOpened={setGeneratePDFOpen}


            />

        </div >
    )
}

export default ServiceInfo
